export default {
    movimientosCajas: [],
    movimientosCajasFiltros: [],
    movimientosCajasExport: [],
    movimientosCajasFiltersExport: [],
    movimientosOtros: [],
    cajas: [],
    cajasFiltros: [],
    cajasExport: [],
    cajasFiltersExport: [],
    statusApiCodigoC: {
        message: "",
        success: ""
    },
    statusApiCaja: {
        message: "",
        success: ""
    },
    totalMovimientosCaja: 0,
    totalCajas: 0
}